import qs from 'qs';
import request from '@/config/request';

/*
  获取雪茄列表
  cigarName
*/
export function getCigarList({ page, pageSize, ...rest }) {
  return request({
    url: `/product/getCigarList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  获取店铺列表
*/
export function getShopList() {
  return request({
    url: '/brand/getShopList',
    method: 'post',
  });
}

/*
  获取全部品牌含系列分类
*/
export function getAllBrandListAndSeries() {
  return request({
    url: '/brand/getAllBrandListAndSeries',
    method: 'post',
  });
}

/*
  获取配件列表
  boutiqueName，boutiqueCategory，
*/
export function getBoutiqueList({ page, pageSize, ...rest }) {
  return request({
    url: `/product/getBoutiqueList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  获取定制列表
*/
export function getPersonalMadeList() {
  return request({
    url: '/product/getPersonalMadeList',
    method: 'post',
  });
}

/*
  获取全部品牌分类
*/
export function getAllBrandList() {
  return request({
    url: '/brand/getAllBrandList',
    method: 'post',
  });
}

/*
  配件导出
  boutiqueName,boutiqueCategory
*/
export function exportBoutique({ boutiqueName, boutiqueCategory }) {
  return request({
    url: '/product/exportBoutique',
    method: 'get',
    params: {
      boutiqueName,
      boutiqueCategory,
    },
    responseType: 'blob',
  });
}

/*
  雪茄导出
  cigarName
*/
export function exportCigar(cigarName) {
  return request({
    url: '/product/exportCigar',
    method: 'get',
    params: {
      cigarName,
    },
    responseType: 'blob',
  });
}

/*
  添加配件
  boutiqueName, boutiqueEnglishName, boutiqueDetail, boutiqueSort,boutiqueCategory,boutiqueUrl
*/
export function addBoutique(rest) {
  return request({
    url: '/product/addBoutique',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  添加雪茄
  cigarName, cigarEnglishName, brandId, seriesId,cigarStrength,cigarLong，cigarFlavor，
  cigarRing，cigarSort，cigarDetail，cigarUrl
*/
export function addCigar(rest) {
  return request({
    url: '/product/addCigar',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  添加定制
  madeName, madeContent
*/
export function addPersonalMade(rest) {
  return request({
    url: '/product/addPersonalMade',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  删除配件
  id
*/
export function deleteBoutique(id) {
  return request({
    url: '/product/deleteBoutique',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  删除配件
  id
*/
export function deleteCigar(id) {
  return request({
    url: '/product/deleteCigar',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  删除定制
  id
*/
export function deletePersonalMade(id) {
  return request({
    url: '/product/deletePersonalMade',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  获取配件详情
  id
*/
export function getBoutique(id) {
  return request({
    url: '/product/getBoutique',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  获取雪茄详情
  id
*/
export function getCigar(id) {
  return request({
    url: '/product/getCigar',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  获取定制详情
  id
*/
export function getPersonalMade(id) {
  return request({
    url: '/product/getPersonalMade',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  编辑雪茄
  id，cigarName, cigarEnglishName, brandId, seriesId,cigarStrength,cigarLong，cigarFlavor，
  cigarRing，cigarSort，cigarDetail，cigarUrl
*/
export function updateCigar(rest) {
  return request({
    url: '/product/updateCigar',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  编辑配件
  id,boutiqueEnglishName, boutiqueDetail，boutiqueCategory，boutiqueUrl
*/
export function updateBoutique(rest) {
  return request({
    url: '/product/updateBoutique',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  编辑定制
  id,madeName,madeContent
*/
export function updatePersonalMade(rest) {
  return request({
    url: '/product/updatePersonalMade',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  批量雪茄上下架
  ids，cigarState
*/
export function updateCigarUpAndDown(ids, cigarState) {
  return request({
    url: '/product/updateCigarUpAndDown',
    method: 'post',
    data: qs.stringify({
      ids,
      cigarState,
    }),
  });
}

/*
  配件上下架
  id
*/
export function updateBoutiqueUpAndDown(id) {
  return request({
    url: '/product/updateBoutiqueUpAndDown',
    method: 'post',
    data: qs.stringify({
      id,
    }),
  });
}

/*
  定制上下架
  id
*/
export function updatePersonalMadeUpAndDown(id) {
  return request({
    url: '/product/updatePersonalMadeUpAndDown',
    method: 'post',
    data: qs.stringify({
      id,
    }),
  });
}
// 获取雪茄配件服务图片
export function getOldCustomizeUrl(id) {
  return request({
    url: '/customize/getOldCustomizeUrl',
    method: 'post',
    data: qs.stringify({
      id,
    }),
  });
}
// 更新雪茄配件服务图片
export function updateOldCustomizeUrl(data) {
  return request({
    url: '/customize/updateOldCustomizeUrl',
    method: 'post',
    data: qs.stringify(data),
  });
}
